import type { ReactNode } from 'react';
import Icon, { type IconName } from './Icon.js';

/** Calm, centred, and allowed to feel good ("All clear"). Never a dashed box. */
export default function EmptyState({
  icon,
  title,
  hint,
  action,
}: {
  icon?: IconName;
  title: string;
  hint?: ReactNode;
  action?: ReactNode;
}): JSX.Element {
  return (
    <div className="ui-empty">
      {icon && (
        <span className="ui-empty__icon">
          <Icon name={icon} size={28} />
        </span>
      )}
      <p className="ui-empty__title">{title}</p>
      {hint && <p className="ui-empty__hint">{hint}</p>}
      {action && <div className="ui-empty__action">{action}</div>}
    </div>
  );
}
